import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const nameMap: Record<string, string> = {
  category: '分类浏览',
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
  article: '影视详情',
  about: '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  const items: BreadcrumbItem[] = [
    { label: '首页', href: '/' },
  ];

  let accumulated = '';
  segments.forEach((seg) => {
    accumulated += `/${seg}`;
    const label = nameMap[seg] || seg;
    items.push({ label, href: accumulated });
  });

  return (
    <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, idx) => (
            <li key={item.href} className="flex items-center gap-1">
              {idx > 0 && (
                <span className="text-foreground-400 mx-1">/</span>
              )}
              {idx === items.length - 1 ? (
                <span className="text-foreground-600">{item.label}</span>
              ) : (
                <Link
                  to={item.href!}
                  className="text-foreground-500 hover:text-primary-600 transition-colors"
                >
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}

export function getBreadcrumbSchema(items: BreadcrumbItem[], baseUrl = 'https://www.shenmashipin.com') {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.label,
      item: item.href ? `${baseUrl}${item.href}` : undefined,
    })),
  };
}